var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconStorygameBgmTts = function SvgIconStorygameBgmTts(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.23 20.5v-3.109c0-.14.141-.238.274-.193.454.157 1.373.445 1.993.445.85 0 1.14-.18 1.336-1.015.111-.474.426-2.335.512-2.846a.198.198 0 0 1 .152-.16l.982-.228a.678.678 0 0 0 .458-.353.597.597 0 0 0-.013-.558L15.625 12a80.947 80.947 0 0 1-1.33-2.221.202.202 0 0 1-.026-.098C14.242 6.218 11.556 3.5 7.818 3.5c-3.67 0-6.66 2.699-6.796 6.075-.111 1.339.17 3.069 1.613 4.686.717.804 1.25 1.88 1.25 2.737V20.5",
    stroke: "#000",
    strokeOpacity: 0.9,
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4 11c.384.75.6 1.6.6 2.5 0 .9-.216 1.75-.6 2.5M21.712 9A8.46 8.46 0 0 1 23 13.5a8.46 8.46 0 0 1-1.288 4.5",
    stroke: "#000",
    strokeOpacity: 0.9,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgIconStorygameBgmTts;